<template>
  <v-ons-page class="cards-page">

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button></v-ons-back-button>
      </div>
      <div class="center">{{ sales ? 'Find a Sales Rep' : 'Company Directory' }}</div>
    </v-ons-toolbar>

    <v-ons-list class="flex-none">
      <v-ons-list-item>
        <v-ons-input
          class="flex-row"
          :placeholder= "sales ? 'Enter name, county, or zip code' : 'Search' "
          underbar
          v-model="filterText">
        </v-ons-input>
      </v-ons-list-item>
    </v-ons-list>

    <div v-show="employees.length > 0">
      <div v-for="employee in filteredEmployees" v-html="employee.url" v-show="employee.url && !employee.url.endsWith('.html')"></div>
    </div>

    <div
      v-show="filteredEmployees.length === 0 && !!filterText"
      class="flex-column flex-grow align-items-center"
      style="padding-top: 50px;">
      No results match your search.
    </div>

  </v-ons-page>
</template>


<script>
import { global } from '../global.js'

export default {
  name: 'contact-cards',
  props: {
    sales: Boolean,
    employees: Array
  },
  data () {
    return {
      filterText: '',
      menuIsOpen: false
    }
  },
  methods: {

  },
  computed:{
    filteredEmployees() {
      let searchText = this.filterText.toLowerCase();
      let fes = this.employees.filter(e => {
        return this.sales ? e.SalesRepSearch.toLowerCase().includes(searchText) : e.EmployeeSearch.toLowerCase().includes(searchText)
      });

      return fes;
    }
  },
  created() {
    if (global.IS_APP) {
      this.employees.forEach(employee => {
        let success = (fileEntry) => {
          //console.log('success', employee.url);
          fileEntry.file(function (file) {
            let reader = new FileReader();

            reader.onloadend = function (e) {
              employee.url = this.result;
            };

            reader.readAsText(file);
          });
        };
        let error = (e) => {
          console.log('error', e);
        };
        window.resolveLocalFileSystemURL(employee.url, success, error);
      });
    }
    setTimeout(() => {
      document.getElementsByClassName("text-input")[0].focus();
    }, 600);
  }
}
</script>

<style scoped>
  .card img {
    width: 100px;
  }

  ons-input {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/ContactCards.vue